import { EngagementSection, GraphRow } from './components/EngagementSection';
import { GraphImpact } from './components/GraphImpact';
import { GraphSatisfaction } from './components/GraphSatisfaction';
import LookerDashboardLayout from '../../components/LookerDashboardLayout';

export function LookerOverviewDashboard() {
  return (
    <LookerDashboardLayout>
      <EngagementSection />
      <GraphRow>
        <GraphImpact />
        <GraphSatisfaction />
      </GraphRow>
    </LookerDashboardLayout>
  );
}
